/**
 * Filters as plain data, so a page can remember them, show them as chips and share them between
 * pages. One filter is a key (team, status, skill…) with the values picked for it. Values of one
 * filter are OR, different filters are AND.
 */
export type FilterKey = string;
export type FilterValueId = string;

export interface FilterSelection {
    /** the values picked per filter; a filter without values is off */
    values: Record<FilterKey, FilterValueId[]>;
    /** filters added with "+ Filter", shown as chips even while empty */
    added: FilterKey[];
}

export const EMPTY_FILTER_SELECTION: FilterSelection = { values: {}, added: [] };

export interface FilterOption {
    id: FilterValueId;
    label: string;
    /** an 8px state dot in front of the label, only for values that carry a state colour */
    dot?: string;
}

export interface FilterDefinition {
    key: FilterKey;
    label: string;
    /** one line under the filter in the "+ Filter" menu */
    hint?: string;
    options: FilterOption[];
}

/** The values one item has for each filter (a person in two teams has two team values). */
export type FilterItemValues = Record<FilterKey, FilterValueId[]>;

/** How many items each value would leave, given all the other filters. */
export type FilterCounts = Record<FilterKey, Record<FilterValueId, number>>;

/** The pages that keep saved views. */
export type FilterViewPage = "live" | "heatmap" | "dispatch" | "jobs";

/** A saved set of filters for one page, kept on the person's account. */
export interface FilterView {
    id: string;
    name: string;
    page: FilterViewPage;
    /** the people filters, status included, on pages that list people */
    people?: FilterSelection;
    /** the Jobs bar's filters on the dispatch board and the jobs page */
    jobs?: FilterSelection;
}
